import type { Movie } from '@/types';

interface DetailHeroProps {
  movie: Movie;
  onShare: () => void;
  copied: boolean;
}

export default function DetailHero({ movie, onShare, copied }: DetailHeroProps) {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={movie.backdrop}
          alt={`${movie.title} 剧照`}
          title={`${movie.title} 剧情介绍与角色`}
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/92 via-primary-950/70 to-primary-950/55"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col gap-6 md:flex-row md:items-end">
          <div className="h-56 w-40 shrink-0 overflow-hidden rounded-lg border border-background-100/20 bg-background-200 md:h-64 md:w-44">
            <img src={movie.poster} alt={`${movie.title} 海报`} title={`${movie.title} 剧情介绍`} className="h-full w-full object-top" />
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded bg-accent-500 px-2 py-1 font-label text-[11px] text-background-50">{movie.category}</span>
              <span className="flex items-center gap-1 rounded bg-background-50/15 px-2 py-1 font-label text-[11px] text-accent-200 backdrop-blur-sm">
                <i className="ri-star-fill text-[10px]"></i>{movie.rating.toFixed(1)} 分
              </span>
              <span className="flex items-center gap-1 rounded bg-background-50/15 px-2 py-1 font-label text-[11px] text-background-100 backdrop-blur-sm">
                <i className="ri-eye-line text-[10px]"></i>{(movie.views / 10000).toFixed(1)}万 浏览
              </span>
            </div>
            <h1 className="mt-3 font-heading text-3xl font-black text-background-50 md:text-4xl">{movie.title}</h1>
            <p className="mt-2 text-sm text-background-200/90">{movie.subtitle}</p>

            <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-xs text-background-100/95">
              <span className="flex items-center gap-1"><i className="ri-user-star-line"></i> 导演 · {movie.director}</span>
              <span className="flex items-center gap-1"><i className="ri-group-line"></i> 主演 · {movie.cast.join(' / ')}</span>
              <span className="flex items-center gap-1"><i className="ri-calendar-line"></i> {movie.year}</span>
              <span className="flex items-center gap-1"><i className="ri-earth-line"></i> {movie.region}</span>
              <span className="flex items-center gap-1"><i className="ri-time-line"></i> {movie.duration}</span>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              {movie.genres.map((g) => (
                <span key={g} className="rounded-full border border-background-100/30 px-3 py-1 font-label text-xs text-background-100">
                  {g}
                </span>
              ))}
              <button
                type="button"
                onClick={onShare}
                className="ml-auto inline-flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap cursor-pointer"
              >
                <i className={copied ? 'ri-check-line' : 'ri-link'}></i>
                {copied ? '链接已复制' : '分享 · 复制链接'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}